<div class="keypad" role="group" [attr.aria-label]="'pin.pinKeypad' | translate">
  @for (row of keys; track $index) {
    <div class="keypad-row">
      @for (key of row; track key) {
        @if (key === '') {
          <div class="key key-empty"></div>
        } @else if (key === 'delete') {
          <button
            class="key key-delete"
            type="button"
            (click)="onKey('delete')"
            [disabled]="disabled"
            role="button"
            [attr.aria-label]="'pin.delete' | translate"
          >
            <ion-icon name="backspace-outline"></ion-icon>
          </button>
        } @else {
          <button
            class="key key-digit"
            type="button"
            (click)="onKey(key)"
            [disabled]="disabled"
            role="button"
            [attr.aria-label]="key"
          >
            {{ key }}
          </button>
        }
      }
    </div>
  }
</div>
